<template>
  <div class="forget-container">
    <div class="forget-card">
      <!-- 标题 -->
      <div class="forget-title">
        <div>忘记密码?</div>
      </div>

      <!-- 忘记密码表单 -->
      <el-form
        ref="forgetForm"
        :model="forgetForm"
        :rules="forgetRules"
        class="forget-form"
      >
        <!-- 手机号输入 -->
        <el-form-item prop="phone">
          <div class="input-wrapper">
            <img
              src="@/assets/image/sjh1.png"
              class="input-icon"
              alt="手机图标"
            >
            <el-input
              v-model="forgetForm.phone"
              placeholder="请输入你的手机号码"
              name="phone"
              type="text"
              tabindex="1"
              auto-complete="on"
            />
          </div>
        </el-form-item>

        <!-- 验证码输入 -->
        <el-form-item prop="code">
          <div class="input-wrapper code-input">
            <img
              src="@/assets/image/code1.png"
              class="input-icon"
              alt="验证码图标"
            >
            <el-input
              v-model="forgetForm.code"
              placeholder="请输入你的验证码"
              name="code"
              type="text"
              tabindex="2"
              auto-complete="off"
            />
            <el-button
              type="text"
              size="small"
              class="code-btn"
              :disabled="codeCountdown > 0"
              @click="sendCode"
            >
              {{ codeCountdown > 0 ? `${codeCountdown}s` : '获取验证码' }}
            </el-button>
          </div>
        </el-form-item>

        <!-- 新密码输入 -->
        <el-form-item prop="newPassword">
          <div class="input-wrapper">
            <img
              src="@/assets/image/psw1.png"
              class="input-icon"
              alt="密码图标"
            >
            <el-input
              :key="passwordType"
              ref="newPassword"
              v-model="forgetForm.newPassword"
              :type="passwordType"
              placeholder="请输入你的新密码"
              name="newPassword"
              tabindex="3"
              auto-complete="off"
            />
            <span
              class="show-pwd"
              @click="showPwd"
            >
              <svg-icon :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'" />
            </span>
          </div>
        </el-form-item>

        <!-- 确认按钮 -->
        <el-button
          :loading="loading"
          type="primary"
          class="confirm-btn"
          @click.native.prevent="handleSubmit"
        >
          确定
        </el-button>
      </el-form>
    </div>
  </div>
</template>

<script>
import { sendForgetSmsCode, resetPassword } from '@/api/user'

export default {
  name: 'Forget',
  data() {
    const validatePhone = (rule, value, callback) => {
      if (!/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
      }
    }
    const validateCode = (rule, value, callback) => {
      if (!/^\d{6}$/.test(value)) {
        callback(new Error('请输入6位验证码'))
      } else {
        callback()
      }
    }
    const validateNewPassword = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error('密码不能少于6位'))
      } else {
        callback()
      }
    }
    return {
      forgetForm: {
        phone: '',
        code: '',
        newPassword: ''
      },
      forgetRules: {
        phone: [{ required: true, trigger: 'blur', validator: validatePhone }],
        code: [{ required: true, trigger: 'blur', validator: validateCode }],
        newPassword: [{ required: true, trigger: 'blur', validator: validateNewPassword }]
      },
      loading: false,
      passwordType: 'password',
      codeCountdown: 0
    }
  },
  methods: {
    showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = ''
      } else {
        this.passwordType = 'password'
      }
      this.$nextTick(() => {
        this.$refs.newPassword.focus()
      })
    },
    handleSubmit() {
      this.$refs.forgetForm.validate(valid => {
        if (valid) {
          this.loading = true
          // 调用重置密码API
          const data = {
            mobile: this.forgetForm.phone,
            captcha: this.forgetForm.code,
            newpassword: this.forgetForm.newPassword
          }
          resetPassword(data).then(response => {
            this.loading = false
            this.$message.success('密码重置成功，请使用新密码登录')
            this.$router.push('/login')
          }).catch(error => {
            this.loading = false
            console.error('密码重置失败:', error)
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    sendCode() {
      if (this.codeCountdown > 0) return

      this.$refs.forgetForm.validateField('phone', (errorMessage) => {
        if (errorMessage) {
          this.$message.error(errorMessage)
          return
        }

        // 调用发送忘记密码验证码API
        const data = {
          mobile: this.forgetForm.phone,
          event: 'resetpwd'
        }

        sendForgetSmsCode(data).then(response => {
          // 开始倒计时
          this.codeCountdown = 60
          const timer = setInterval(() => {
            this.codeCountdown--
            if (this.codeCountdown <= 0) {
              clearInterval(timer)
            }
          }, 1000)

          this.$message.success('验证码已发送')
        }).catch(error => {
          console.error('发送验证码失败:', error)
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.forget-container {
  min-height: 100vh;
  width: 100%;
  background: url('~@/assets/image/bg1.png') center/cover no-repeat;
  display: flex;
  align-items: center;
  justify-content: end;
  position: relative;
  overflow: hidden;
}

.forget-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 40px;
  width: 480px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  margin-right: 10%;

  .forget-title {
    margin-bottom: 30px;

    div {
      color: #111111;
      font-size: 20px;
      font-weight: 600;
      margin: 0;
      position: relative;

      &::after {
        content: '';
        position: absolute;
        bottom: -8px;
        left: 10%;
        transform: translateX(-50%);
        width: 60px;
        height: 2px;
        background: #0f6fe2;
        border-radius: 1px;
      }
    }
  }

  .forget-form {
    .input-wrapper {
      position: relative;
      display: flex;
      align-items: center;
      border: 1px solid #e0e0e0;
      border-radius: 8px;
      padding: 0 15px;
      background: #fff;
      transition: all 0.3s ease;

      &:focus-within {
        border-color: #4a90e2;
        box-shadow: 0 0 0 3px rgba(74, 144, 226, 0.1);
      }

      .input-icon {
        width: 20px;
        height: 20px;
        margin-right: 10px;
        flex-shrink: 0;
      }

      .el-input {
        flex: 1;

        ::v-deep .el-input__inner {
          border: none;
          background: transparent;
          padding: 15px 0;
          font-size: 14px;
          color: #333;

          &::placeholder {
            color: #999;
          }
        }
      }

      .show-pwd {
        cursor: pointer;
        color: #999;
        margin-left: 10px;
        padding: 5px;
        border-radius: 4px;
        transition: all 0.3s ease;

        &:hover {
          color: #4a90e2;
          background: rgba(74, 144, 226, 0.1);
        }
      }

      &.code-input {
        .code-btn {
          margin-left: 10px;
          height: 36px;
          border-radius: 6px;
          font-size: 12px;
          color: #0f6fe2;
          font-weight: bold;
          background: transparent;
          border: none;
          padding: 0;

          &:hover {
            color: #0f6fe2;
            background: transparent;
          }

          &:disabled {
            color: #999;
          }
        }
      }
    }

    .confirm-btn {
      width: 100%;
      height: 48px;
      border-radius: 8px;
      font-size: 16px;
      font-weight: 600;
      background: linear-gradient(90deg, #0f6fe2, #0c89f2);
      border: none;
      margin-top: 20px;
      transition: all 0.3s ease;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 8px 25px rgba(74, 144, 226, 0.3);
      }
    }
  }
}

// 响应式设计
@media (max-width: 1200px) {
  .forget-card {
    width: 380px;
    padding: 30px;
  }
}

@media (max-width: 768px) {
  .forget-container {
    padding: 20px;
  }

  .forget-card {
    width: 100%;
    max-width: 400px;
    padding: 25px;
  }
}
</style>
